const Resources = {

    table_headers: [
        {
            text:      'Assignment',
            align:    'start',
            value:     'assignment',
            type:     'link',
        },
        {
            text:       'Associate',
            value:      'associate_name'
        },
        {
            text:       'Date',
            value:      'date',
        },
        {
            text:       'Include In Productivity',
            value:      'include_productivity',
            type:       'boolean'
        }
    ],

    unassigned_work_table_headers: [
        {
            text:      'Minutes',
            align:    'start',
            value:     'minutes',
        },
        {
            text:       'Description of work',
            value:      'description'
        },
        {
            text:       'Added at',
            value:      'created_at',
            type:       'date',
        },
    ],

    discharge_beds_table_headers: [
        {
            text:      '#',
            align:    'start',
            value:     '',
        },
        {
            text:       'Bed code',
            value:      'bed_code'
        },
        {
            text:       'Minutes',
            value:      'minutes'
        },
        // {
        //     text:       'Associate',
        //     value:      'associate_id'
        // },
        {
            text:       'Added at',
            value:      'created_at',
            type:       'date',
        },
        {
            text:       'Actions',
            value:      '',
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Census',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Log Productivity',
            href:   '/census-log-productivity',
            arrow:  "",
        },
    ],

    helps: [
        {
            label: '¿How to log productivity manually in Census?', 
            instruction: `https://scribehow.com/embed/Logging_Productivity_Manually_in_Census__0o7zKGgJTL-OpQBwxWqc7w?as=scrollable`
        },
    ],

}

export default Resources;